import React from 'react';

export default function ItemDemanda({ demanda }) {
  const formatarData = (data) => {
    if (!data) return 'N/A';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getOrigemInfo = () => {
    if (demanda.tipo_usuario_origem === 1) {
      return { icon: 'fas fa-mobile-alt', text: 'App', class: 'origem-app' };
    }
    if (demanda.tipo_usuario_origem === 2) {
      return { icon: 'fab fa-whatsapp', text: 'WhatsApp', class: 'origem-whatsapp' };
    }
    return { icon: 'fas fa-question', text: 'N/A', class: 'origem-unknown' };
  };

  const getStatusClass = () => {
    const statusId = demanda.status_id;
    switch (statusId) {
      case 1: return 'status-recebida';
      case 2: return 'status-concluida';
      case 3: return 'status-encaminhada';
      default: return 'status-nova';
    }
  };

  const origem = getOrigemInfo();

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
      {/* Coluna da esquerda - Informações principais */}
      <div style={{ flex: 2 }}>
        <div className="obra-header">
          <div>
            <h3 className="obra-title">{demanda.categoria_nome || 'Categoria não informada'}</h3>
            <span className={`obra-status ${getStatusClass()}`}>
              {demanda.status_nome || 'Nova'}
            </span>
          </div>
        </div>

        <div className="obra-info" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="obra-info-item">
            <strong>Solicitante:</strong> {demanda.usuario_nome || 'Não identificado'}
          </div>
          <div className="obra-info-item">
            <strong>Protocolo:</strong> #{demanda.id}
          </div>
          <div className="obra-info-item">
            <strong>Data:</strong> {formatarData(demanda.created_at)}
          </div>
          <div className="obra-info-item">
            <strong>Prioridade:</strong> {demanda.prioridade || 'Normal'}
          </div>
          {demanda.endereco && (
            <div className="obra-info-item" style={{ gridColumn: '1 / -1' }}>
              <strong>Endereço:</strong> {demanda.endereco}
            </div>
          )}
        </div>
        
        <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
          <strong>Descrição:</strong> {demanda.descricao || 'Sem descrição disponível'}
        </div>
      </div>
      
      {/* Coluna do meio - Origem e Status */}
      <div style={{ flex: 1 }}>
        <div style={{ 
          marginBottom: '15px', 
          padding: '8px 12px', 
          backgroundColor: origem.class === 'origem-app' ? '#e8f5e8' : '#e8f8f5', 
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <i className={origem.icon} style={{ color: origem.class === 'origem-app' ? '#2e7d32' : '#16a085' }}></i>
          <span style={{ fontSize: '14px', fontWeight: 'bold', color: origem.class === 'origem-app' ? '#2e7d32' : '#16a085' }}>
            Origem: {origem.text}
          </span>
        </div>
        
        {demanda.resposta && (
          <div style={{ 
            padding: '8px 12px', 
            backgroundColor: '#e8f5e8', 
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <i className="fas fa-reply" style={{ color: '#2e7d32' }}></i>
            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#2e7d32' }}>
              Respondida
            </span>
          </div>
        )}
        
        {demanda.setor_encaminhamento_descricao && (
          <div style={{ 
            marginTop: '10px',
            padding: '8px 12px', 
            backgroundColor: '#fff3cd', 
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <i className="fas fa-share" style={{ color: '#856404' }}></i>
            <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#856404' }}>
              Encaminhada para: {demanda.setor_encaminhamento_descricao}
            </span>
          </div>
        )}
      </div>
      
      {/* Coluna da direita - Ações */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end' }}>
        <div className="obra-actions" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button className="button btn-demanda-primary" style={{ width: '100%' }}>
            <i className="fas fa-eye"></i>
            Ver Detalhes
          </button>
        </div>
      </div>
    </div>
  );
}